module.exports = __webpack_public_path__ + "static/media/GoalHead.939377b8.png";